import { render, staticRenderFns } from "./kc_form1900.vue?vue&type=template&id=276e6650&"
import script from "./kc_form1900.vue?vue&type=script&lang=js&"
export * from "./kc_form1900.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports